'use client';

import { Elements, RecurlyProvider } from '@recurly/react-recurly';
import Script from 'next/script';
import { JSX, useState } from 'react';
import { BillingInfo, PaymentMethodType, PaymentProfileResponse } from 'subscription-service-client';

import CreditCardInfoForm from './creditCardInfoForm';
import DigitalWalletInfoForm from './digitalWalletInfoForm';
import PaypalInfoForm from './paypalInfoForm';

export default function RecurlyBillingInfoWrapper({
    publicKey,
    billingInfo,
    paymentProfile,
}: {
    publicKey: string;
    billingInfo: BillingInfo | null;
    paymentProfile: PaymentProfileResponse | null;
}): JSX.Element {
    const [scriptLoaded, setScriptLoaded] = useState(false);

    const isDigitalWallet =
        billingInfo?.paymentMethodType === PaymentMethodType.ApplePay ||
        billingInfo?.paymentMethodType === PaymentMethodType.GooglePay;

    if (isDigitalWallet && paymentProfile) {
        return (
            <div>
                <DigitalWalletInfoForm paymentProfile={paymentProfile} />
            </div>
        );
    }

    return (
        <div>
            <Script src="https://js.recurly.com/v4/recurly.js" onLoad={() => setScriptLoaded(true)} />
            {/* // Suspense ensures these components will not load until after the Script */}
            {scriptLoaded && (
                // All components that use data from Recurly need to be encapsulated in Recurly's client-side wrapper.
                <RecurlyProvider publicKey={publicKey}>
                    <Elements>
                        {billingInfo?.paymentMethodType === PaymentMethodType.Paypal ? (
                            <PaypalInfoForm billingInfo={billingInfo} />
                        ) : (
                            <CreditCardInfoForm billingInfo={billingInfo ?? undefined} />
                        )}
                    </Elements>
                </RecurlyProvider>
            )}
        </div>
    );
}
